import { useRef } from 'react';
import { Link } from 'react-router-dom';
import ComicCard from '@/components/base/ComicCard';
import { comics } from '@/mocks/comics';

export default function FeaturedSection() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const featuredComics = comics.filter((c) => c.featured || c.hot).slice(0, 6);

  const scroll = (direction: 'left' | 'right') => {
    if (scrollRef.current) {
      const scrollAmount = 260;
      scrollRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth',
      });
    }
  };

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 lg:px-10">
        <div className="max-w-7xl mx-auto">
          <div className="flex items-end justify-between mb-10">
            <div>
              <span className="inline-block px-3 py-1 bg-primary-500 text-background-50 text-xs font-semibold rounded-md mb-3 whitespace-nowrap">
                HOT
              </span>
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
                热门<span className="text-primary-500">推荐</span>
              </h2>
              <p className="text-sm text-foreground-500 mt-2">
                精选优质韩漫，发现你的下一个最爱
              </p>
            </div>
            <div className="hidden md:flex items-center gap-2">
              <button
                type="button"
                onClick={() => scroll('left')}
                className="w-9 h-9 flex items-center justify-center rounded-full border border-foreground-300 text-foreground-500 hover:bg-foreground-950 hover:text-background-50 hover:border-foreground-950 transition-all cursor-pointer"
                aria-label="向左滚动"
              >
                <i className="ri-arrow-left-s-line text-lg"></i>
              </button>
              <button
                type="button"
                onClick={() => scroll('right')}
                className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-950 text-background-50 hover:bg-foreground-800 transition-all cursor-pointer"
                aria-label="向右滚动"
              >
                <i className="ri-arrow-right-s-line text-lg"></i>
              </button>
            </div>
          </div>

          <div
            ref={scrollRef}
            className="flex gap-5 overflow-x-auto pb-4 scrollbar-hide -mx-4 px-4"
            style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
          >
            {featuredComics.map((comic) => (
              <ComicCard
                key={comic.id}
                id={comic.id}
                title={comic.title}
                category={comic.category}
                cover={comic.cover}
                rating={comic.rating}
                hot={comic.hot}
                status={comic.status}
                chapters={comic.chapters}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}